/**
 * Created by coolguy on 2017/7/7.
 */
import React from 'react';
import {connect} from 'react-redux';
import {Upload, message, Progress} from 'antd';
import {Image} from '../../util/ApiList';

import {cal_file_name,getBase64,getExt,formatSign,beforeUpload} from '../../util/image.js';

const {store} = Image;
const ImageStoreUrl = store.url;

class Uploader extends React.Component {
    static defaultProps = {
        showProgress:true,
        limitSize:20
    };
    state = {
        progress: 0
    };
    uploadParam = {};
    formatSign = (sign) => {
        return Object.assign(this.uploadParam,formatSign(sign));
    };

    beforeUpload = (file) => {
        return beforeUpload(file,this.props.directory, this.props.limitSize).then((key)=>{
            this.uploadParam.key = key;
        })
    };
    handleImgChange = (info) => {
        let {uploadFinish,base64} = this.props;
        //console.log(info);
        if (info.file.status === 'done') {
            if(base64){
                getBase64(info.file.originFileObj, imageUrl => uploadFinish && uploadFinish({
                    uploadParam:this.uploadParam,
                    imageUrl
                }));
            }else{
                //目前已经没有使用原图了，所以如果不需要就先不拿原图的base64
                uploadFinish && uploadFinish({uploadParam:this.uploadParam}, info.file);
            }
            // Get this url from response in real world.


            this.setState({
                progress: 100
            }, () => {
                setTimeout(() => {
                    this.setState({
                        progress: 0
                    })
                }, 1000)
            })
        } else {
            if (info && info.event && info.event.percent) {
                this.setState({
                    progress: info.event.percent
                })
            }
        }
    };

    render() {
        let {image, showProgress, className, inline, tip, accept, showUploadList, wrapperStyle} = this.props;
        if (!image || !image.sign) {
            return null;
        }

        var uploadProps = {

        };

        if(accept) {
            uploadProps.accept = accept;
        }

        return (
            <div style={Object.assign({width: "100%", marginBottom: tip ? 20 : 0}, wrapperStyle || {})}>
                <div className={className || "dp-f a-c j-c"} style={{position:'relative'}}>
                    <Upload
                        className={"avatar-uploader"}
                        style={Object.assign({flex: 1}, this.props.style)}
                        name="file"
                        showUploadList={showUploadList || false}
                        data={this.formatSign(image.sign)}
                        action={ImageStoreUrl}
                        beforeUpload={this.beforeUpload}
                        onChange={this.handleImgChange}
                        {...uploadProps}
                    >
                        {this.props.children}
                    </Upload>
                    {this.state.progress && showProgress ?
                        <div className="avatar-uploader-progress dp-f" style={this.props.hideLoading ? {top:30} : null}>
                            <Progress percent={Math.round(this.state.progress)} showInfo={false}/>
                        </div>
                    : null}
                </div>
            </div>

        )
    }
}


export default connect((state) => ({
    image: state.image
}))(Uploader);



// WEBPACK FOOTER //
// ./src/components/Common/Uploader.js